<template>
  <header v-if="item">
  <div class="translate">
    <button v-on:click="isHidden = !isHidden">He</button>
    <button v-on:click="isHidden = true">En</button>
  </div>
  
<a href="https://mysong.co.il/" target="_blank" class="header-left-logo"></a>

    <ul v-if="!isHidden" class="nav" :key="user.id">
      <li v-for="widget in widgets" :key="widget.id" class="">
        
        <router-link v-if="widget.type != 'link' && widget.link != false && widget.link != '' && widget.link != undefined" :to="widget.link" v-text="widget.title" :class="((widget.link.indexOf('/home') != -1 && ($route.path == '/item/' + item.id || $route.path == '/item/' + item.id + '/')) ? 'router-link-active':'')"></router-link>
        <a v-else-if="widget.type == 'link'" v-text="widget.title" :href="widget.link" target="_blank"></a>
        <a v-else v-text="widget.title"></a>
        
        <div v-if="widget.type == 'download' && (is_logged || item.allow_anonymous_download == '1')">
          <a  v-for="file in widget.files" :key="file.title"  :href="file.url">{{ file.title }} <i class="fa fa-download"></i></a>
        </div>
        <div v-if="widget.type == 'download' && !(is_logged || item.allow_anonymous_download == '1')">
          <a  v-for="file in widget.files" :key="file.title" @click="$emit('open_login_pop')">{{ file.title }} <i class="fa fa-download"></i></a>
        </div>

      </li>
    </ul>

    <ul v-if="isHidden" class="nav" :key="user.id">
      <li v-for="widget in widgets" :key="widget.id" class="">
        
        <router-link v-if="widget.type != 'link' && widget.link != false && widget.link != '' && widget.link != undefined" :to="widget.link" v-text="widget.title_en != null ? widget.title_en : widget.title" :class="((widget.link.indexOf('/home') != -1 && ($route.path == '/item/' + item.id || $route.path == '/item/' + item.id + '/')) ? 'router-link-active':'')"></router-link>
        <a v-else-if="widget.type == 'link'" v-text="widget.title_en != null ? widget.title_en : widget.title" :href="widget.link" target="_blank"></a>
        <a v-else v-text="widget.title_en != null ? widget.title_en : widget.title"></a>
        
        <div v-if="widget.type == 'download' && (is_logged || item.allow_anonymous_download == '1')">
          <a  v-for="file in widget.files" :key="file.title"  :href="file.url">{{ file.title }} <i class="fa fa-download"></i></a>
        </div>
        <div v-if="widget.type == 'download' && !(is_logged || item.allow_anonymous_download == '1')">
          <a  v-for="file in widget.files" :key="file.title" @click="$emit('open_login_pop')">{{ file.title }} <i class="fa fa-download"></i></a>
        </div>

      </li>
    </ul>

  </header>
</template>

<script>
export default {
  
 data() {
    return {
      isHidden: false
    }
  },
  props: ["widgets", "item", "user"],
  created(){
    
  },
  computed: {
    is_logged(){
      if (this.user)
      { 
      return (this.user.id > 0);
      }
      return false;
    }
  }
}
</script>
<style>
.translate{
  display: flex;
    flex-flow: column;
    width: 32px;
    position: absolute;
    left: 170px;
    top: 8px;
}
.translate button{
  background: #000;
  margin: 2px;
  border: none;
  color: #fff;
}
</style>